import { Value } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const ADDCOLUMN = (
  table: Value,
  array: Value,
  number?: Value,
): Value => {
  if (!Array.isArray(table)) {
    throw new Error('ADDCOLUMN expects a table as the first argument');
  }

  if (!Array.isArray(array)) {
    throw new Error('ADDCOLUMN expects an array as the second argument');
  }

  if (number === undefined) {
    return pushColumn(table, array);
  }

  if (typeof number !== 'number') {
    throw new Error('ADDCOLUMN expects a number as the third argument');
  }

  return insertColumn(table, array, number);
};

const pushColumn = (table: Value[], col: Value[]): Value[] => {
  return table.map((row, i) => {
    if (!Array.isArray(row)) {
      throw new Error(`ADDCOLUMN invalid row at index ${i}`);
    }

    return [...row, col[i] ?? null];
  });
};

const insertColumn = (table: Value[], col: Value[], index: number): Value[] => {
  const maxColumns = table.reduce((max: number, row, i) => {
    if (!Array.isArray(row)) {
      throw new Error(`ADDCOLUMN invalid row at index ${i}`);
    }

    return Math.max(max, row.length);
  }, 0);

  const clampedIndex = Math.min(Math.max(index, 0), maxColumns);

  return table.map((row, i) => {
    // @ts-expect-error: We know that row is an array because we checked in maxColumns reduce.
    const newRow = [...row];
    newRow.splice(clampedIndex, 0, col[i] ?? null);
    return newRow;
  });
};

export default wrapFunction(ADDCOLUMN, {
  name: 'ADDCOLUMN',
  nargs: 2,
  types: ['array', 'array', 'number'],
});
